import React from 'react'

interface ICribSheetList {
    entries: Array<any>;
    setDeleteEntry: (e: any, idx: number) => void
    setEditEntry: (e: any, idx: number) => void;
    itemStyle?: any
}

const CribSheetList = (props: ICribSheetList) => {
    const { entries, setDeleteEntry, setEditEntry } = props;

    if (entries?.length === 0) return null

    return (
        <>
            {entries?.map((e, idx) => (
                <div key={e?.headline} style={props?.itemStyle} className="lcs-edit-mini">
                    <div className="lcs-edit-mini__header">
                        <h4 className="lcs-edit-mini__title">{e.headline}</h4>
                        <div className="lcs-edit-mini__actions">
                            <button onClick={() => setEditEntry(e, idx)} className="lcs-edit-mini__btn lcs-edit-mini__btn--edit">
                                <img src="/assets/images/edit-pencil-icon.svg" alt="edit" />
                            </button>
                            <button
                                className="lcs-edit-mini__btn lcs-edit-mini__btn--delete"
                                onClick={() => setDeleteEntry(e, idx)}
                            >
                                <img src="/assets/images/trash-red-icon.svg" alt="delete" />
                            </button>
                        </div>
                    </div>
                    <p className="lcs-edit-mini__desc">
                        {e.description}
                    </p>
                </div>
            ))}
        </>
    )
}

export default CribSheetList